import React from 'react';
const testimonials = [{
  name: 'María G.',
  role: 'Lectora verificada',
  content: 'Siempre sentí que había algo más, pero los libros de espiritualidad me parecían muy densos. Esta guía es diferente. Es clara, visual y me ayudó a entender mis propias emociones de una forma que nunca había logrado. El diario de preguntas fue un antes y un después para mí.',
  avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80'
}, {
  name: 'Alejandro M.',
  role: 'Lector verificado',
  content: 'No soy una persona mística, soy bastante analítico. Pero la forma en que este libro explica los chakras y la energía vital como mapas de conciencia hizo que todo tuviera sentido. Las prácticas del bono de activación me han ayudado a reducir mi ansiedad diaria.',
  avatar: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80'
}, {
  name: 'Sofía R.',
  role: 'Lectora verificada',
  content: 'Hermoso visualmente y profundo en contenido. Me encantó cómo explica la geometría sagrada y la glándula pineal sin caer en exageraciones. Es exactamente lo que necesitaba para ordenar mis pensamientos y empezar a meditar con un propósito real.',
  avatar: 'https://images.unsplash.com/photo-1531123897727-8f129e1bf98c?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80'
}, {
  name: 'Diego L.',
  role: 'Lector verificado',
  content: 'Compré el libro por curiosidad y terminé devorándolo en dos días. Los bonos son increíbles, especialmente el mapa de los chakras. Ahora entiendo por qué me sentía estancado en ciertas áreas de mi vida. Totalmente recomendado si buscas claridad.',
  avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80'
}];
export function TestimonialsSection() {
  return <section className="py-20 bg-[#0a0a0a]" data-id="element-186">
      <div className="max-w-7xl mx-auto px-5 md:px-8" data-id="element-187">
        <div className="text-center mb-16" data-id="element-188">
          <h2 className="text-3xl md:text-4xl font-poppins font-bold text-white mb-4" data-id="element-189">
            Lo que dicen quienes ya comenzaron su viaje
          </h2>
          <div className="h-1 w-20 bg-amber-500 mx-auto rounded-full" data-id="element-190"></div>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-191">
          {testimonials.map((t, idx) => <div key={idx} className="bg-white/5 border border-white/10 p-8 rounded-2xl relative" data-id="element-192">
              <div className="absolute top-6 right-8 text-amber-500/20 text-6xl font-serif" data-id="element-193">
                "
              </div>
              <div className="flex items-center mb-6" data-id="element-194">
                <img src={t.avatar} alt={t.name} className="w-14 h-14 rounded-full object-cover border-2 border-amber-500/50 mr-4" data-id="element-195" />
                <div data-id="element-196">
                  <h4 className="text-white font-bold font-poppins" data-id="element-197">
                    {t.name}
                  </h4>
                  <div className="flex text-amber-400 text-sm mt-1" data-id="element-198">★★★★★</div>
                  <span className="text-gray-500 text-xs" data-id="element-199">{t.role}</span>
                </div>
              </div>
              <p className="text-gray-300 italic relative z-10" data-id="element-200">
                "{t.content}"
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}